/**
* Nom : doubleAuthentication.js
* Description : Ce fichier contient la définition de la page doubleAuthentication 
*               Cette page fourni un champ pour rentrer le code de double authentification reçu par mail
* Date de création : 29 juillet 2025
*/

/* CSS et assets */
import { Boxibrain_logo } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { InputForm } from 'package_ui_ihm/dist'
import { Link } from 'react-router-dom'

/* Hook */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useScreenWidth } from 'package_ui_ihm/dist';


/**
* DoubleAuthentication : affiche une page avec un champ pour rentrer le code de double authentification reçu par mail
*
* Type : page 
*
* Parametres : 
*  None
*/
function DoubleAuthentication() {

    // Define useState hooks
    const [generatedCode, setGeneratedCode] = useState('');
    const [code, setCode] = useState('');
    const [codeError, setCodeError] = useState(null);
    const [codeStatus, setCodeStatus] = useState(null);


    // Define useContext hooks
    const { authToken, currentUser, currentUserId, confirmLogin } = useAuth();
    const { path, setPreviousUrl } = useApi();
    const { setMonths, setValidationStatus, setTargetTypes } = useData();

    const navigate = useNavigate();
  

    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendDoubleAuthenticationRequest() {
        // Token
        const token = "Bearer " + authToken
        // request double authentication
        const response = await fetch(path + "/api/au-erus/" + currentUserId + "/double-authentication/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const data = await response.json();
        setGeneratedCode(data['validation_code'])
    }

    async function sendRequestToUpdateClientInfo() {
        // Token
        const token = "Bearer " + authToken
        // request double authentication
        await fetch(path + "/api/au-erus/" + currentUserId + "/change-client-info/", 
            {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
                body: ""
            }
        );
    }

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
        accept: 'application/json',
        Authorization: token,
        }
        // Requests in parallel to win time 
        const [resMonth, resValidationStatus, resTargetType] = await Promise.all([
            // Months
            fetch(path + "/api/bo-moth/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Validation status
            fetch(path + "/api/bo-vast/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Target types
            fetch(path + "/api/bo-taty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataMonth, dataValidationStatus, dataTargetType] = await Promise.all([
            resMonth.json(),
            resValidationStatus.json(),
            resTargetType.json(),
        ])
        // Set context variables
        setMonths(dataMonth["results"])
        setValidationStatus(dataValidationStatus["results"])
        setTargetTypes(dataTargetType["results"])
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(code === null || code === ''){
            setCodeError(true)
        }
        else
        {   
            setCodeError(false)
        }
    };


    // Define useEffect hooks
    useEffect(() => {
        sendDoubleAuthenticationRequest()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(codeError != null){
            if(codeError === false && code === generatedCode){
                setCodeStatus(true)
            }
            else{
                setCodeStatus(false)
                setCodeError(null)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codeError]);

    useEffect(() => {
        if(codeStatus === true && currentUser["is_active"] === 1 && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH")) 
        {
            confirmLogin(true)
            sendRequestToUpdateClientInfo()
            retrieveData()
            if(currentUser["must_change_password"] === 1)
            {
                setPreviousUrl('/')
                navigate('/password-edit')
            } else {
                navigate('/menu')
            }
        }
        else if(codeStatus === true && currentUser["is_active"] === 1 && (currentUser["role_name"] === "AT_SUPPORT")) 
        {
            confirmLogin(true)
            sendRequestToUpdateClientInfo()
            if(currentUser["must_change_password"] === 1)
            {
                setPreviousUrl('/')
                navigate('/password-edit')
            } else {
                navigate('/equipments')
            }
        } else if(codeStatus !== null){
            confirmLogin(false)
            //navigate('/')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codeStatus]);


    // Render component
    return (
        <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
            <form onSubmit={handleSubmit} className='flex-column form-center'>
                <div className='flex-row'>
                    <img src={Boxibrain_logo} alt='Boxibrain logo' className={(screenWidth > 650) ? 'image-login' : 'image-login-ss'} />
                </div>
                {(screenWidth > 650) ? (
                    <h1 className='authent-text'>Nous vous avons envoyé un code de vérification de connexion par mail</h1>
                ) : (
                    <h2 className='authent-text'>Nous vous avons envoyé un code de vérification de connexion par mail</h2>
                )}
                <p className='zero-marge-padding margin-bottom center-text'>Veuillez entrer ci-dessous le code reçu par mail pour valider votre connexion.</p>
                {(codeStatus !== null && codeStatus === false) ? (
                    <p className='form-error'>Vous n'êtes pas autorisé à accéder à cette application.</p>
                ) : (
                    null
                )}   
                <InputForm error={codeError} type="text" label="Code" value={code} setValue={setCode} disabled={false}/>
                <button type="submit" className='button'>Valider</button>
            </form> 
            <footer className="footer">
                <p className='center-text'>©{new Date().getFullYear()} Asclepios Tech SAS. Tout droits réservés. <Link to={'/policy'} className='link-text'>Politique de confidentialité</Link></p>
            </footer>
        </div>
    );
}

export default DoubleAuthentication;

